import {defaultService} from '../service'
import {loaderAtom} from '../../store/recoil/loader'
import {useSetRecoilState} from 'recoil'
import {alertAtom} from '../recoil/alert'

interface GetProductAllListProps {
  page: number
  size: number
  searchType: string,
  keyword: string
}

export const UserProductAction = () => {

  const loader = useSetRecoilState(loaderAtom)
  const setAlert = useSetRecoilState(alertAtom)

  const getProductList = async (id: number) => {

    loader({isLoading: true})

    return await defaultService.handleService({
      method: 'post',
      endPoint: `/product/categoryProductList`,
      params: {
        category_id: id
      }
    }).then(
      response => {
        loader({
          isLoading: false
        })
        return response.data.payload
      },
      error => {
        loader({
          isLoading: false
        })
        setAlert({
          title: error.name,
          type: 'alert',
          message: error.message,
          isShow: true
        })
      }
    )
  }

  const getProductDetail = async (id: number) => {

    loader({isLoading: true})

    return await defaultService.handleService({
      method: 'post',
      endPoint: `/product/detail`,
      params: {id: id}
    }).then(
      response => {
        loader({
          isLoading: false
        })
        return response.data.payload
      },
      error => {
        loader({
          isLoading: false
        })
        setAlert({
          title: error.name,
          type: 'alert',
          message: error.message,
          isShow: true
        })
      }
    )
  }

  const getProductAllList = async (params: GetProductAllListProps) => {

    loader({isLoading: true})

    return await defaultService.handleService({
      method: 'post',
      endPoint: `/product/list`,
      params: params
    }).then(
      response => {
        loader({
          isLoading: false
        })
        return response.data.payload
      },
      error => {
        loader({
          isLoading: false
        })
        setAlert({
          title: error.name,
          type: 'alert',
          message: error.message,
          isShow: true
        })
      }
    )
  }

  return {
    getProductList,
    getProductDetail,
    getProductAllList
  }
}
